export function getDialogContainer() {
    const { body } = document;
    return body && body.tagName !== "FRAMESET" ? body : document.documentElement;
}
